import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { IntelActionItem, IntelActionPriority } from '../model/contracts'

const PRIORITY_ORDER: Record<IntelActionPriority, number> = {
  high: 0,
  med: 1,
  low: 2,
}

const PRIORITY_BADGE_STYLES: Record<IntelActionPriority, string> = {
  high: 'bg-destructive/10 text-destructive border-destructive/30',
  med: 'bg-muted text-foreground border-border',
  low: 'bg-muted text-muted-foreground border-border',
}

interface IntelActionItemsProps {
  items: IntelActionItem[]
}

export function IntelActionItems({ items }: IntelActionItemsProps) {
  const { t } = useTranslation('intel')

  if (items.length === 0) {
    return (
      <div className="rounded-xl border border-border bg-card p-5 shadow-sm">
        <p className="text-sm text-muted-foreground">{t('actions.empty')}</p>
      </div>
    )
  }

  const sorted = [...items].sort(
    (a, b) => PRIORITY_ORDER[a.priority] - PRIORITY_ORDER[b.priority],
  )

  return (
    <ol className="flex flex-col gap-3">
      {sorted.map((item) => (
        <li
          key={item.id}
          className="relative flex flex-col gap-2 rounded-xl border border-border bg-card p-4 shadow-sm"
        >
          <span
            className={cn(
              'absolute right-4 top-4 rounded-full border px-2 py-0.5 text-xs font-semibold',
              PRIORITY_BADGE_STYLES[item.priority],
            )}
          >
            {t(`actions.priority.${item.priority}`)}
          </span>
          <p className="pr-20 text-sm font-semibold text-foreground">{item.title}</p>
          <p className="text-sm text-muted-foreground">{item.body}</p>
        </li>
      ))}
    </ol>
  )
}
